export var Lang;
(function (Lang) {
    Lang["ZHO"] = "zho";
    Lang["ENG"] = "eng";
    Lang["ZHO_TW"] = "zho-tw";
    Lang["ZHO_HK"] = "zho-hk";
    Lang["UDM"] = "udm";
    Lang["JPN"] = "jpn";
    Lang["IND"] = "ind";
    Lang["KOR"] = "kor";
    Lang["RUS"] = "rus";
    Lang["ARA"] = "ara";
    Lang["SPA"] = "spa";
    Lang["PON"] = "pon";
    Lang["POR"] = "por";
    Lang["FRA"] = "fra";
    Lang["DEU"] = "deu"; // 德语
})(Lang || (Lang = {}));
//# sourceMappingURL=types.js.map